module.exports = __webpack_public_path__ + "static/media/test2.ec269a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/test2.png
// module id = 810
// module chunks = 0